import { useIntl } from "react-intl";
import { Logo } from "@oai/platform/ui/Icon";

import { messages } from "@/localization/Shared.messages";

export default function NotFound() {
  const intl = useIntl();

  return (
    <div className="bg-surface flex min-h-0 w-full flex-1 flex-col items-center justify-center text-center">
      <Logo color="var(--gray-1000)" width="32px" height="32px" />
      <h3 className="mt-4 mb-2 p-0 text-2xl font-semibold tracking-tight">
        {intl.formatMessage(messages.notFoundTitle)}
      </h3>
      <div className="text-secondary">{intl.formatMessage(messages.notFoundDescription)}</div>
    </div>
  );
}
